var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateRolesV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5269 8.2175C9.80991 7.50048 8.83741 7.09766 7.82339 7.09766C6.80936 7.09766 5.83687 7.50048 5.11984 8.2175C4.40282 8.93452 4 9.90702 4 10.921",
    stroke: "white",
    strokeWidth: 0.811023,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82334 7.09785C9.23107 7.09785 10.3723 5.95666 10.3723 4.54892C10.3723 3.14119 9.23107 2 7.82334 2C6.41561 2 5.27441 3.14119 5.27441 4.54892C5.27441 5.95666 6.41561 7.09785 7.82334 7.09785Z",
    stroke: "white",
    strokeWidth: 0.811023,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64868 7.77344C2.8136 7.77344 2.01272 8.10517 1.42223 8.69566C0.831735 9.28616 0.5 10.087 0.5 10.9221",
    stroke: "white",
    strokeWidth: 0.811023,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64892 7.77246C2.48961 7.77246 1.5498 6.83265 1.5498 5.67334C1.5498 4.51403 2.48961 3.57422 3.64892 3.57422",
    stroke: "white",
    strokeWidth: 0.811023,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.64258C12.078 7.64258 13.3574 8.92204 13.3574 10.5C13.3574 12.078 12.078 13.3574 10.5 13.3574C8.92204 13.3574 7.64258 12.078 7.64258 10.5C7.64258 8.92204 8.92204 7.64258 10.5 7.64258ZM10.5 9C10.2239 9 10 9.22386 10 9.5V10H9.5C9.22386 10 9 10.2239 9 10.5C9 10.7761 9.22386 11 9.5 11H10V11.5C10 11.7761 10.2239 12 10.5 12C10.7761 12 11 11.7761 11 11.5V11H11.5C11.7761 11 12 10.7761 12 10.5C12 10.2239 11.7761 10 11.5 10H11V9.5C11 9.22386 10.7761 9 10.5 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateRolesV2);
export default __webpack_public_path__ + "static/media/createRolesV2.b2b08818d2ed035df0e2022623427d3b.svg";
export { ForwardRef as ReactComponent };